export const categories = [
  { key: "all", label: "全部快讯" },
  { key: "hot", label: "热点" },
  { key: "ent", label: "娱乐" },
  { key: "film", label: "影视" },
  { key: "variety", label: "综艺" },
  { key: "tech", label: "科技圈" },
  { key: "life", label: "生活" },
];

export type NewsItem = {
  id: string;
  category: string;
  tag: string;
  title: string;
  summary: string;
  content: string[];
  image: string;
  time: string;
  views: string;
  featured?: boolean;
};

const img = {
  ent: "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20evening%20stage%20with%20spotlights%20and%20elegant%20golden%20bokeh%20crowd%20silhouettes%20warm%20cinematic%20editorial%20photography&width=900&height=560&seq=cap-ent-01&orientation=landscape",
  film: "https://readdy.ai/api/search-image?query=moody%20cinema%20theatre%20with%20deep%20red%20seats%20and%20glowing%20projector%20beam%20with%20dust%20particles%20atmospheric%20dramatic%20warm%20tones&width=900&height=560&seq=cap-film-01&orientation=landscape",
  variety: "https://readdy.ai/api/search-image?query=colorful%20tv%20variety%20game%20show%20studio%20stage%20with%20vibrant%20circular%20spotlights%20and%20confetti%20energetic%20warm%20festive%20lighting&width=900&height=560&seq=cap-variety-01&orientation=landscape",
  hot: "https://readdy.ai/api/search-image?query=lively%20night%20city%20street%20crowded%20with%20warm%20neon%20signs%20and%20lanterns%20glowing%20lively%20editorial%20street%20photography%20mood&width=900&height=560&seq=cap-hot-01&orientation=landscape",
  concert: "https://readdy.ai/api/search-image?query=huge%20outdoor%20music%20festival%20crowd%20silhouettes%20raising%20hands%20under%20golden%20concert%20stage%20lights%20at%20night%20energetic%20atmosphere&width=1200&height=760&seq=cap-hero-01&orientation=landscape",
  studio: "https://readdy.ai/api/search-image?query=cozy%20podcast%20recording%20studio%20warm%20amber%20lighting%20with%20microphone%20and%20headphones%20on%20desk%20intimate%20editorial%20shot&width=900&height=560&seq=cap-studio-01&orientation=landscape",
  interview: "https://readdy.ai/api/search-image?query=warm%20studio%20interview%20scene%20with%20two%20designer%20armchairs%20side%20table%20and%20soft%20lamp%20light%20cozy%20magazine%20editorial&width=900&height=560&seq=cap-interview-01&orientation=landscape",
  backstage: "https://readdy.ai/api/search-image?query=television%20studio%20backstage%20corridor%20glowing%20with%20rig%20lights%20and%20camera%20silhouettes%20cinematic%20warm%20amber&width=900&height=560&seq=cap-backstage-01&orientation=landscape",
  award: "https://readdy.ai/api/search-image?query=shiny%20golden%20award%20trophy%20standing%20on%20glossy%20dark%20table%20under%20warm%20spotlight%20with%20golden%20bokeh%20celebratory%20elegant&width=900&height=560&seq=cap-award-01&orientation=landscape",
  phone: "https://readdy.ai/api/search-image?query=close%20up%20of%20hand%20holding%20glowing%20smartphone%20with%20entertainment%20app%20interface%20in%20cozy%20cafe%20bokeh%20warm%20lifestyle%20candid&width=900&height=560&seq=cap-phone-01&orientation=landscape",
  set: "https://readdy.ai/api/search-image?query=film%20production%20set%20with%20camera%20dolly%20and%20warm%20practical%20lights%20silhouettes%20of%20crew%20working%20evening%20cinematic%20mood&width=900&height=560&seq=cap-set-01&orientation=landscape",
  life: "https://readdy.ai/api/search-image?query=cozy%20lifestyle%20flatlay%20with%20latte%20art%20coffee%20magazine%20and%20phone%20on%20warm%20wooden%20table%20morning%20soft%20light%20editorial&width=900&height=560&seq=cap-life-01&orientation=landscape",
};

export const newsList: NewsItem[] = [
  {
    id: "hot-001",
    category: "hot",
    tag: "头条",
    title: "重磅 · 跨年音乐季官宣阵容，粉丝连夜排队话题引爆全网",
    summary: "年度音乐盛典阵容揭晓，超二十组艺人集结，售票与直播安排同步公开，实时热度登顶今日热搜。",
    content: [
      "昨晚九点，筹备半年的跨年音乐季正式官宣完整阵容，二十余组音乐人将在三天内轮番登台。消息发布仅十分钟，#跨年音乐季阵容# 相关话题便冲上各平台热搜第一。",
      "主办方表示，本届主打“回到现场”，现场舞美将采用升级版沉浸式灯光与舞台设计，并同步开放高清直播与多机位视角，满足无法到场的观众追更需求。",
      "据官方票务页面显示，早鸟票已于今日十点开抢，部分热门场次上架后短时间内即显示“售罄补货中”。后续加场与观演攻略将陆续通过官方渠道第一时间同步。",
    ],
    image: img.concert,
    time: "8 分钟前",
    views: "36.2w",
    featured: true,
  },
  {
    id: "hot-002",
    category: "hot",
    tag: "热点",
    title: "明星红毯造型出炉，多套高定首穿惊艳全场登上热搜",
    summary: "年度时尚盛典红毯开启，多位艺人首穿高定亮相，造型话题接连霸榜，现场花絮实时更新中。",
    content: [
      "年度时尚盛典红毯今日下午拉开帷幕，现场灯光璀璨，多位艺人以首穿高定造型亮相，瞬间成为镜头焦点。",
      "从复古剪裁到大胆撞色，红毯造型各具风格，造型师团队也通过社交平台同步分享背后的设计灵感与造型过程，引发热烈讨论。",
      "目前相关造型话题接连登上热搜，官方图库与现场花絮正持续更新，想看更多高清现场可直接锁定本页实时快讯。",
    ],
    image: img.ent,
    time: "26 分钟前",
    views: "28.7w",
    featured: true,
  },
  {
    id: "hot-003",
    category: "hot",
    tag: "热点",
    title: "新晋剧集口碑爆棚，一周连上三次热搜引发追剧潮",
    summary: "都市题材新剧上线一周热度飙升，台词片段全网刷屏，观众自发玩梗催更，话题阅读量破十亿。",
    content: [
      "一部聚焦都市青年成长的剧集上线仅一周，便凭借扎实的剧情与真实的台词引发广泛共鸣，相关话题阅读量已突破十亿。",
      "剧中多个名场面被网友二次创作，表情包与台词梗快速出圈，甚至带动了取景地的打卡热潮。",
      "主创团队透露，第二季已在筹备阶段，更多幕后花絮将于近期释出，追更党可以持续关注最新动态。",
    ],
    image: img.film,
    time: "1 小时前",
    views: "24.9w",
  },
  {
    id: "ent-001",
    category: "ent",
    tag: "独家",
    title: "独家探访录音棚，人气歌手自曝新专辑录制进度",
    summary: "人气歌手在录音棚独家分享新专辑筹备细节，透露将与多位制作人合作，首支单曲下月上线。",
    content: [
      "海角爆记者今日受邀探访人气歌手所在的录音棚，他大方分享了新专辑的创作与录制进度，状态轻松且充满热情。",
      "据介绍，新专辑尝试了更多元的曲风，并与多位知名制作人展开合作，首支先行单曲预计下月中旬与歌迷见面。",
      "录音间隙他还透露巡演筹备已在同步进行，更多城市站次信息将陆续公布，请以官方渠道为准。",
    ],
    image: img.studio,
    time: "2 小时前",
    views: "19.3w",
  },
  {
    id: "ent-002",
    category: "ent",
    tag: "动态",
    title: "颁奖礼在即，提名名单公布后多家媒体发布预测",
    summary: "年度音乐与影视奖项提名陆续公布，各路媒体与乐评人纷纷给出预测，竞争进入白热化阶段。",
    content: [
      "随着年度奖项提名名单的陆续公布，围绕最佳作品的讨论热度持续升温，多家行业媒体已发布各自的获奖预测。",
      "业内人士分析，今年提名作品类型多元，含金量与观赏性兼具，最终结果颇具悬念。",
      "颁奖礼将于下周举行，红毯直播与获奖感言等第一手内容，本站将持续第一时间同步。",
    ],
    image: img.award,
    time: "3 小时前",
    views: "15.6w",
  },
  {
    id: "ent-003",
    category: "ent",
    tag: "现场",
    title: "影展见面会现场直击：主创与影迷互动金句频出",
    summary: "新片影展见面会现场人气爆棚，导演与主演畅聊创作幕后，互动环节笑点密集，票根收集热潮兴起。",
    content: [
      "新片影展见面会今日举行，现场座无虚席。导演与主演分享了许多拍摄过程中的幕后趣事，互动环节金句频出，气氛热烈。",
      "面对影迷关于角色与续作的提问，主创团队坦诚回应，并预告将有官方幕后纪录片与大家见面。",
      "见面会结束后，许多影迷在社交平台晒出珍藏票根，相关话题正稳步攀升至热搜榜。",
    ],
    image: img.backstage,
    time: "今天 11:40",
    views: "12.4w",
  },
  {
    id: "film-001",
    category: "film",
    tag: "院线",
    title: "年度大片定档春节档，特效团队首曝预告细节",
    summary: "备受期待的年度视效大片宣布定档，制作团队首度公开预告细节，称将带来沉浸式视觉体验。",
    content: [
      "筹备多年的年度视效大片今日正式宣布定档春节档，并同步放出首支预告。特效团队表示，片中大量镜头采用全流程视效合成，观感极具冲击力。",
      "制作人透露，为了让观众获得更沉浸的观影体验，团队对声画细节反复打磨，影院规格也将覆盖多种特殊厅。",
      "上映前将陆续释出制作特辑与主创访谈，海角爆将持续跟进最新院线排期与票务动态。",
    ],
    image: img.set,
    time: "4 小时前",
    views: "22.1w",
    featured: true,
  },
  {
    id: "film-002",
    category: "film",
    tag: "剧集",
    title: "高分悬疑剧迎来大结局，编剧埋下的伏笔逐一回收",
    summary: "高分悬疑剧迎来收官，剧迷连夜梳理伏笔线，结局讨论度持续攀升，主创将开启线上答疑。",
    content: [
      "口碑高企的悬疑剧昨夜迎来大结局，此前埋设的多处伏笔在终章中被逐一回收，让不少剧迷大呼过瘾。",
      "结局播出后，关于真相与人物命运的讨论迅速刷屏，各平台的剧情解析帖阅读量节节攀升。",
      "主创团队预告，将于近期开启线上直播答疑，与观众面对面聊一聊剧集幕后与结局设定。",
    ],
    image: img.film,
    time: "今天 10:20",
    views: "18.8w",
  },
  {
    id: "film-003",
    category: "film",
    tag: "动态",
    title: "动画电影突破票房纪录，周边产品上线即被抢空",
    summary: "口碑动画电影票房持续走高刷新纪录，联名周边上线后迅速售罄，官方宣布将紧急补货。",
    content: [
      "口碑动画电影票房持续走高，正式刷新同档期纪录，其治愈系故事打动了大批观众。",
      "随着热度攀升，影片联名周边一经上线便被抢购一空，不少影迷在社交平台“求补货”，官方宣布将紧急加单。",
      "影片主题曲与多支制作花絮也已上线，想了解周边补货时间与更多幕后，可随时关注实时更新。",
    ],
    image: img.variety,
    time: "今天 09:35",
    views: "16.5w",
  },
  {
    id: "variety-001",
    category: "variety",
    tag: "新综",
    title: "户外竞技综艺回归，全新玩法与录制地点率先曝光",
    summary: "人气户外竞技综艺宣布回归，节目组率先曝光全新玩法与录制地点，嘉宾阵容官宣引发期待。",
    content: [
      "人气户外竞技综艺今日官宣回归，全新季玩法迎来大升级，录制地点横跨多地，视觉效果全面升级。",
      "节目组介绍，本季将加入更多实时互动的赛制环节，观众可通过多平台参与投票，直接影响游戏走向。",
      "完整嘉宾阵容与首播时间将于近日陆续公布，敬请锁定本站获取第一时间官宣消息。",
    ],
    image: img.variety,
    time: "5 小时前",
    views: "21.3w",
    featured: true,
  },
  {
    id: "variety-002",
    category: "variety",
    tag: "综艺",
    title: "慢综艺收官口碑不俗，嘉宾合体巡演计划提上日程",
    summary: "治愈系慢综艺迎来温暖收官，网友好评如潮，嘉宾们透露将有线下合体活动，详情正在推进。",
    content: [
      "一档主打慢节奏与治愈氛围的综艺迎来收官，节目中嘉宾之间的真诚互动给观众留下深刻印象，口碑不俗。",
      "收官夜，多位嘉宾在线互动并透露，线下合体见面会与特别企划已在推进之中，具体安排将择期公布。",
      "更多收官花絮与嘉宾动态正在持续更新，感兴趣的用户可继续追更本站相关专题。",
    ],
    image: img.interview,
    time: "今天 08:50",
    views: "13.9w",
  },
  {
    id: "variety-003",
    category: "variety",
    tag: "幕后",
    title: "竞演节目幕后花絮释出，导师点评金句引热议",
    summary: "竞演节目释出幕后花絮，导师犀利又温柔的点评成为焦点，相关话题成功登上热搜。",
    content: [
      "人气竞演节目今日释出一批幕后花絮，导师们在排练现场的专业指导与温暖鼓励引发热议，多段点评被赞“金句”。",
      "花絮还展现了选手们备战的高强度日常，真实又动人的片段拉近了观众与节目的距离。",
      "下期节目看点与更多幕后故事将持续释出，敬请关注实时快讯更新。",
    ],
    image: img.backstage,
    time: "昨天",
    views: "11.2w",
  },
  {
    id: "tech-001",
    category: "tech",
    tag: "发布",
    title: "旗舰新品发布会定档，折叠屏与影像技术成为焦点",
    summary: "科技厂商年度发布会官宣定档，多款旗舰新品将亮相，折叠屏形态与全新影像算法备受期待。",
    content: [
      "头部科技厂商今日官宣年度发布会定档时间，将带来包括折叠屏旗舰在内的多款新品。",
      "爆料信息显示，新品在铰链设计与影像算法上有明显升级，续航与快充同样值得期待，相关讨论热度快速上升。",
      "发布会将全程直播，届时海角爆将第一时间整理关键参数与上手感受，帮助读者快速掌握一手信息。",
    ],
    image: img.phone,
    time: "6 小时前",
    views: "14.6w",
  },
  {
    id: "tech-002",
    category: "tech",
    tag: "数码",
    title: "新款真无线耳机体验分享：降噪与续航均有提升",
    summary: "编辑部实测新款真无线耳机，主动降噪与综合续航表现亮眼，通勤与办公场景体验如何？",
    content: [
      "编辑部拿到新款真无线耳机进行了一段时间的实测体验。在嘈杂的通勤场景下，其主动降噪能够带来明显的安静感。",
      "综合续航方面，单次充电配合充电盒可满足多日使用，佩戴舒适度与低延迟连接也有不错表现。",
      "当然，每款产品都有取舍，具体参数对比与使用建议可查看完整体验内容，帮你在选购时少走弯路。",
    ],
    image: img.studio,
    time: "昨天",
    views: "9.7w",
  },
  {
    id: "tech-003",
    category: "tech",
    tag: "行业",
    title: "智能出行再提速：多品牌公布城市落地与体验升级计划",
    summary: "智能出行领域迎来新一轮提速，多个品牌公布更多城市落地计划与体验优化细节，行业竞争加剧。",
    content: [
      "智能出行赛道近期迎来新一轮提速，多个品牌接连公布下一阶段的落地城市与体验升级计划。",
      "从安全冗余到智能调度，厂商正围绕更顺滑的用户体验展开角力，行业竞争也随之加剧。",
      "针对普通用户最关心的覆盖范围、费用与乘坐体验，海角爆将持续跟进并带来一手实测反馈。",
    ],
    image: img.hot,
    time: "3 天前",
    views: "8.1w",
  },
  {
    id: "life-001",
    category: "life",
    tag: "生活方式",
    title: "咖啡店探店热度走高，手冲与城市慢生活成新趋势",
    summary: "一批主打手冲与城市慢生活的小店走红，探店视频刷屏，成为周末放松的新去处。",
    content: [
      "近期，一批主打手冲咖啡与城市慢生活氛围的小店在社交平台走红，探店视频接连刷屏。",
      "店主们普遍更看重豆子风味与空间体验，点上一杯手冲、安静坐一下午，成为不少上班族周末放松的新选择。",
      "我们整理了几家口碑与风格各具特色的小店，适合约上朋友一起打卡，感受城市的另一面。",
    ],
    image: img.life,
    time: "今天 12:05",
    views: "10.3w",
  },
  {
    id: "life-002",
    category: "life",
    tag: "健康",
    title: "熬夜追更党请注意：科学睡眠小贴士帮你找回状态",
    summary: "追更虽快乐，睡眠要保障。整理几条科学睡眠建议，帮你平衡快乐追更与规律作息。",
    content: [
      "追更的快乐人人都懂，但长期熬夜也会悄悄透支精力。如何在快乐追更与规律作息之间找到平衡，是很多朋友关心的话题。",
      "建议设定固定的追更时段，避免在临睡前长时间刷屏；白天适当运动、午间小憩，都能帮助改善夜间睡眠质量。",
      "当然，偶尔熬夜也不必焦虑，第二天及时补觉、调整饮食，身体状态很快就能恢复。保持适度，快乐更长久。",
    ],
    image: img.life,
    time: "2 天前",
    views: "7.6w",
  },
];

export const hotRank = [
  { word: "#跨年音乐季阵容官宣#", heat: "962.1w", cat: "综艺" },
  { word: "#年度时尚盛典红毯#", heat: "881.5w", cat: "娱乐" },
  { word: "#高分悬疑剧大结局#", heat: "793.2w", cat: "影视" },
  { word: "#新剧一周三次上热搜#", heat: "710.8w", cat: "热点" },
  { word: "#户外竞技综艺回归#", heat: "664.3w", cat: "综艺" },
  { word: "#人气歌手新专辑录制#", heat: "552.7w", cat: "娱乐" },
  { word: "#动画电影票房纪录#", heat: "498.9w", cat: "影视" },
  { word: "#折叠屏旗舰新品#", heat: "431.6w", cat: "科技圈" },
  { word: "#手冲咖啡探店热#", heat: "356.4w", cat: "生活" },
  { word: "#年度大片定档春节档#", heat: "312.8w", cat: "影视" },
];

export const tickerItems = [
  "跨年音乐季官宣阵容，早鸟票今日开抢",
  "年度时尚盛典红毯造型接连霸榜热搜",
  "高分悬疑剧收官，主创将开启线上答疑",
  "户外竞技综艺回归，新玩法率先曝光",
  "人气歌手独家探访录音棚，新专辑筹备中",
  "旗舰新品发布会定档，折叠屏受关注",
  "手冲咖啡小店走红，城市慢生活成趋势",
];

export const timelineUpdates = [
  { time: "14:26", label: "现场", text: "跨年音乐季加场信息已通过官方渠道确认，今晚公布抢票时间线。" },
  { time: "13:50", label: "快讯", text: "年度时尚盛典第二波红毯高清图释出，多套造型细节曝光。" },
  { time: "12:40", label: "独家", text: "人气歌手录音棚探访成片已上线，独家花絮同步放送。" },
  { time: "11:20", label: "热点", text: "高分悬疑剧结局解析帖阅读量突破千万，剧迷持续刷屏。" },
  { time: "10:05", label: "影视", text: "年度大片首支预告播放量破亿，特效团队释出制作手记。" },
  { time: "09:15", label: "综艺", text: "户外竞技综艺完整嘉宾阵容今晚八点官宣，先导片同步上线。" },
];